/**
 * The words for agents: the card that starts them, the panel's rows, and the
 * line a chat shows where their news reached it. Pure, so they are tested.
 */

import type { AgentState } from '../api';

/** One agent a waiting start_agents call would start. */
export interface AgentPlan {
  title: string;
  task: string;
  model: string;
}

/** The agents a waiting start_agents call carries; null if it carries none. */
export function agentPlan(args: string): AgentPlan[] | null {
  let parsed: unknown;
  try {
    parsed = JSON.parse(args);
  } catch {
    return null;
  }
  const list = (parsed as { agents?: unknown } | null)?.agents;
  if (!Array.isArray(list) || !list.length) return null;
  const plans = list.filter(
    (a): a is AgentPlan => typeof a?.title === 'string' && typeof a.task === 'string' && typeof a.model === 'string'
  );
  return plans.length === list.length ? plans : null;
}

export const startHeading = (n: number): string => `Start ${n} agent${n === 1 ? '' : 's'}`;

export const STATE_TEXT: Record<AgentState, string> = {
  working: 'Working',
  done: 'Done',
  failed: 'Did not finish',
  stopped: 'Stopped'
};

/** Where an agent's news reached the chat: “Moodle” finished. */
export function endedLine(a: { title: string; state: Exclude<AgentState, 'working'> }): string {
  const how = a.state === 'done' ? 'finished' : a.state === 'failed' ? 'did not finish' : 'was stopped';
  return `“${a.title}” ${how}`;
}

/** The header's Agents button, as read aloud. */
export const agentsLabel = (working: number): string => (working ? `Agents, ${working} working` : 'Agents');
